var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#1A71FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 14H15.3333C13.4667 14 12 15.4667 12 17.3333V22.6667C12 24.5333 13.4667 26 15.3333 26H24.6667C26.5333 26 28 24.5333 28 22.6667V17.3333C28 15.4667 26.5333 14 24.6667 14ZM15.3333 15.3333H24.6667C25.8 15.3333 26.6667 16.2 26.6667 17.3333H13.3333C13.3333 16.2 14.2 15.3333 15.3333 15.3333ZM24.6667 24.6667H15.3333C14.2 24.6667 13.3333 23.8 13.3333 22.6667V18.6667H26.6667V22.6667C26.6667 23.8 25.8 24.6667 24.6667 24.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6666 23.3333C16.2189 23.3333 16.6666 22.8855 16.6666 22.3333C16.6666 21.781 16.2189 21.3333 15.6666 21.3333C15.1143 21.3333 14.6666 21.781 14.6666 22.3333C14.6666 22.8855 15.1143 23.3333 15.6666 23.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.b239df1ab19dd1acf04495104102a8bd.svg";
export { ForwardRef as ReactComponent };